import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
    <G clipPath="url(#clip0_948_46751)">
      <Path
        opacity={0.2}
        d="M12.1078 13.8303H28.1695C28.5568 13.8303 28.9282 13.9841 29.202 14.2579C29.4758 14.5318 29.6297 14.9032 29.6297 15.2904V28.4318H12.1078V13.8303Z"
        fill={props?.color ?? "#1434CB"}
      />
      <Path
        d="M29.6297 28.4318H12.1078V13.8303"
        stroke={props?.color ?? "#1434CB"}  
        strokeWidth={1.46016}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.6297 18.2108L23.789 23.3213L17.9484 18.9408L12.1078 24.0514"
        stroke={props?.color ?? "#1434CB"}
        strokeWidth={1.46016}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_948_46751">
        <Rect
          width={23.3625}
          height={23.3625}
          fill="white"
          transform="translate(9.1875 9.45001)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
